/**
 * If true, the user has "data saver" turned on and we should
 * limit data usage.
 *
 * This only works on some browsers that tell us what their saveData
 * state is. See the mozilla docs for more info:
 * https://developer.mozilla.org/en-US/docs/Web/API/NetworkInformation/saveData
 */
export const isNetworkMetered = () => {
    var _a, _b, _c;
    //@ts-ignore // This property does exist on some browsers
    return !!((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.connection) &&
        (
        //@ts-ignore // This property does exist on some browsers
        (_c = (_b = window.navigator) === null || _b === void 0 ? void 0 : _b.connection) === null || _c === void 0 ? void 0 : _c.saveData);
};
